export default function getCrossSellingProductsTotal(products) {
  if (!products.length) {
    return 0;
  }
  return products.reduce(
    (total, { priceWithDiscount, price, quantity }) =>
      total + (priceWithDiscount || price) * quantity,
    0,
  );
}
